module.exports = __webpack_public_path__ + "418133a6/img/splash-icon.07a7c465.svg";